"use client";

import { useEffect, useRef } from "react";
import type { PaletteViewMode } from "./usePaletteView";

/** Puts the caret in whichever input the current screen types into. */
export function usePaletteFocus({
  isOpen,
  viewMode,
}: {
  isOpen: boolean;
  viewMode: PaletteViewMode;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const kbInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const focus = setTimeout(() => inputRef.current?.focus(), 20);
    return () => clearTimeout(focus);
  }, [isOpen]);

  // Focus KB input when entering kb-search mode
  useEffect(() => {
    if (viewMode === "kb-search") {
      setTimeout(() => {
        kbInputRef.current?.focus();
      }, 20);
    } else if (viewMode === "root" && isOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 20);
    }
  }, [viewMode, isOpen]);

  return { inputRef, kbInputRef };
}
